import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DPAccount } from './dp-account';
import { DPAccountService } from './dp-accounts.service';
import { DPProject } from './model/dp-project';
import { DPProjectService } from './dp-project.service';
import { DPMarket } from './model/dp-market';
import { Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';



@Component({
    templateUrl: 'dp-project-create.component.html'
})
export class DPProjectCreateComponent implements OnInit {
    @Input() project: DPProject;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    storedStatus = 'active';
    isFirst: any;
    account: DPAccount;
    requestedAccountId: number;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    statuses = ['active'];
    storedSponsored = 0;


    constructor(
        private toasterService: ToasterService,

        private router: Router,
        private _service: NotificationsService,
        private accountService: DPAccountService,
        private projectService: DPProjectService,
        private route: ActivatedRoute) {
    }

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            const account_id = params['account_id'];
            this.requestedAccountId = account_id;
            this.navigated = true;
            this.accountService.getAccount(this.requestedAccountId)
                .then(account => this.account = account);
        });
        this.project = new DPProject();
        this.isFirst = true;
    }


    save1(project: DPProject, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            if (+project.estimated_hours > 999.99 || +project.estimated_hours < 0) {
                this.submitting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                this.notificationContent = 'The hours must be below 999.99 and above 0';
                this.createNotification();
            } else {
                this.submitting = true;
                project.status = this.storedStatus;
                project.sponsored = this.storedSponsored;
              //  console.log(this.storedSponsored);
                this.save(project);
            }
        }
    }

    save(project: DPProject) {
        this.project = project;
        this.projectService
            .createProject(this.requestedAccountId, this.project)
            .then(project => {
                this.project = project;
                this.submitting = false;
                this.goBack(); // saved hero, w/ id if new
            })
            .catch(error => this.errorHandler(error));

    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account/projects', this.requestedAccountId]);
        }
    }
    checkStatus(status: string) {
        this.storedStatus = status;
    }

    checkExistingStatus(status: string) {
        if (this.storedStatus == status) {
            return true;
        } else {
            return false;
        }
    }
    checkSponsored() {
        if (this.storedSponsored == 0) {
            this.storedSponsored = 1;
        }
        else {
            this.storedSponsored = 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-project-create.component.ts